// E.164 Regex
export const e164Regex: RegExp = /^\+?[1-9]\d{1,14}$/;